import React, { useCallback, useReducer, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import moment from "moment";
import { Box, } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { fetchExecutionResultOnTestCaseId } from '../../utils/api';
import CustomChip from '../chips/CustomChip';
import { formatStatusKey, statusChipStyles } from '../TestLaunchDetail/statusColorPallete';
import TableComponent from '../TableComponent';
import DEFAULT_ROUTES from '../../constants/routes';

const initialState = {
    rows: [],
    total: 0,
    paginationModel: { page: 0, pageSize: 25 },
    isLoadingFetchTabularData: false,
    filterModel: {
        items: [],
        quickFilterValues: [],
    },
};

function reducer(state, action) {
    switch (action.type) {
        case "SET_ROWS":
            return { ...state, rows: action.payload || [] };

        case "SET_TOTAL_ROWS_COUNT":
            return { ...state, total: action.payload };

        case "SET_PAGINATION_MODEL":
            return {
                ...state,
                paginationModel: { ...state.paginationModel, ...action.payload },
            };

        case "SET_LOADING_TABULAR":
            return { ...state, isLoadingFetchTabularData: action.payload };

        case "SET_FILTERS":
            return {
                ...state,
                filterModel: {
                    ...action.payload,
                },
            };

        case "RESET":
            return initialState;

        default:
            return state;
    }
}
const ExecutionHistoryTab = ({ data, refetch }) => {

    const { id: testCaseId } = data

    const [state, dispatch] = useReducer(reducer, initialState);
    const { selectedProject } = useSelector((state) => state.projects);

    const navigate = useNavigate();
    const { rows, total, paginationModel, isLoadingFetchTabularData, filterModel } = state;


    const columns = [
        {
            field: 'launchKey',
            headerName: 'Test Launch',
            disableColumnMenu: true,
            sortable: false,
            flex: 1,
            renderCell: (params) => {
                const launchKey = params.value
                return (launchKey ? <span
                    onClick={(e) => {
                        e.stopPropagation();
                        if (params.row && selectedProject?.id && params.row.id) {
                            if (params.row && selectedProject?.id && params.row.launchId) {
                                navigate(
                                    `${DEFAULT_ROUTES.BASE_URL}${DEFAULT_ROUTES.PROJECT}/${selectedProject.id}${DEFAULT_ROUTES.TEST_CASES}/launch-details/${params.row.launchId}`
                                );
                            }
                        }
                    }}
                    style={{ color: '#2563eb', fontWeight: 600, textDecoration: 'none', cursor: 'pointer' }}>{params.value}</span>
                    : '-')
            },
        },
        {
            field: 'status',
            headerName: 'Status',
            disableColumnMenu: true,
            sortable: false,
            renderCell: (params) => {
                const status = formatStatusKey(params.value);
                const style =
                    statusChipStyles[status] ||
                    statusChipStyles["Pending"];
                return (
                    <CustomChip
                        label={status}
                        color={style.color}
                        textColor={style.textColor}
                        borderColor={style.borderColor}
                        icon={style.icon}
                        size="small"
                        rounded={true}
                        style={{ fontWeight: 600 }}
                    />
                );
            },
            disableColumnMenu: true,
            sortable: false,
            flex: 1,
        },
        {
            field: 'executionStartTime',
            headerName: 'Execution Time',
            renderCell: (params) => {
                const date = params.value
                const formattedDate = moment(date).format(
                    "MMM DD, YYYY hh:mm A"
                );

                return date ? formattedDate : '-';
            },
            disableColumnMenu: true,
            sortable: false,
            flex: 1,
        },
        {
            field: 'executedBy',
            headerName: 'Executed By',
            disableColumnMenu: true,
            sortable: false,
            flex: 1,
        },
    ];

    const fetchTabularData = useCallback(async () => {
        dispatch({ type: "SET_LOADING_TABULAR", payload: true }); 
        try {
            const { data } = await fetchExecutionResultOnTestCaseId({
                testCaseId,
                ...state.paginationModel,
                page: state.paginationModel.page + 1,
            });
            dispatch({ type: "SET_ROWS", payload: data?.rows });
            dispatch({
                type: "SET_TOTAL_ROWS_COUNT",
                payload: data?.pagination?.totalItems || data?.totalCount || 0,
            });
        } finally {
            dispatch({ type: "SET_LOADING_TABULAR", payload: false });
        }
    }, [testCaseId, state.paginationModel]);


    useEffect(() => {
        fetchTabularData();
        refetch()
    }, [fetchTabularData]);


    const handleCustomPaginationPageChange = (event, page) => {
        dispatch({
            type: "SET_PAGINATION_MODEL",
            payload: { page },
        });
    };
    const handleCustomPaginationPageSizeChange = (pageSize) => {
        dispatch({
            type: "SET_PAGINATION_MODEL",
            payload: { page: 0, pageSize },
        });
    };
    return (
        <Box sx={{ width: "98%", height: '98%', margin: 'auto', overflow: 'hidden' }}>

            <TableComponent
                viewType="testExecutionResult"
                title="Execution Result"
                headerActionButtons={[]}
                columns={columns}
                rows={rows}
                isCheckbox={false}
                hideColumnsVisibilityButton={true}
                idField="id"
                isPagination={true}
                rowCount={total}
                paginationMode="server"
                paginationModel={paginationModel}
                handleCustomPaginationPageChange={handleCustomPaginationPageChange}
                handleCustomPaginationPageSizeChange={
                    handleCustomPaginationPageSizeChange
                }
                isCustomPagination={true}
                customStyles={{
                    "& .MuiDataGrid-cell": {
                        py: 1,
                    },
                }}
                columnHeaderStyle={{
                    fontWeight: 600,
                    fontSize: "1rem",
                    color: "#0f172a",
                    whiteSpace: "normal",
                    textAlign: "left",
                    padding: 0,
                    lineHeight: 1.2,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    maxHeight: "3em",
                }}
                getRowHeight={() => "auto"}
                getEstimatedRowHeight={() => 100}
                loading={isLoadingFetchTabularData}
                isColumnResizable={!isLoadingFetchTabularData}
            />
        </Box>)
}


export default ExecutionHistoryTab;